import { VOTE_ITEM_TYPE } from "../../../consts/hotColdVote";

import {
  VoteSummary,
  getVoteItemTypeLabel,
} from "../../../services/hotColdVoteServices";

import { BarChart, BarChartSize } from "../../Chart/Bar";

type Props = {
  voteSummary?: VoteSummary;
  size?: BarChartSize;
  showLabel?: boolean;
};

export const HotColdVoteBarChart = ({
  voteSummary,
  size = "small",
  showLabel = false,
}: Props) => {
  const data = [
    {
      count: voteSummary?.hotCount ?? 0,
      label: getVoteItemTypeLabel(VOTE_ITEM_TYPE.HOT),
      color: "bg-[#FF4343]",
    },
    {
      count: voteSummary?.coldCount ?? 0,
      label: getVoteItemTypeLabel(VOTE_ITEM_TYPE.COLD),
      color: "bg-[#0496FF]",
    },
    {
      count: voteSummary?.goodCount ?? 0,
      label: getVoteItemTypeLabel(VOTE_ITEM_TYPE.GOOD),
      color: "bg-[#D1E2EA]",
    },
  ];

  return <BarChart data={data} size={size} showLabel={showLabel} />;
};
